/* Mocks the drawer in ideas portals for the editor */
import { setDrawerStacker } from 'javascripts/drawer_stacker_instance';

class MockSidebar {
  elementIsInDrawer(_el) {
    return false;
  }

  hide() {}
}

export default class MockDrawer {
  constructor() {
    this.mockSidebar = new MockSidebar();
  }

  get sideDrawer() {
    return this.mockSidebar;
  }

  activate() {}

  deActivate() {}

  getActiveDrawerElement() {}

  isDrawerOpen() {}
}

setDrawerStacker(new MockDrawer());
